import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostListener,
	inject,
	signal,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { OperatorStateService } from '../../services/state-services/operator-state.service';

@Component({
	selector: 'app-operator-header',
	imports: [RouterLink],
	templateUrl: './operator-header.component.html',
	styleUrl: './operator-header.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperatorHeaderComponent {
	readonly operatorStateSrv = inject(OperatorStateService);
	private readonly elementRef = inject(ElementRef<HTMLElement>);
	private readonly router = inject(Router);
	readonly storeMenuOpen = signal(false);
	readonly userMenuOpen = signal(false);
	readonly loggingOut = signal(false);

	toggleStoreMenu(): void {
		if ((this.operatorStateSrv.context()?.stores.length ?? 0) < 2) 
			return;
		
		this.userMenuOpen.set(false);
		this.storeMenuOpen.update((open) => !open);
	}

	toggleUserMenu(): void {
		this.storeMenuOpen.set(false);
		this.userMenuOpen.update((open) => !open);
	}

	async switchStore(storeId: string): Promise<void> {
		this.storeMenuOpen.set(false);
		await this.operatorStateSrv.switchStore(storeId);
	}

	async logout(): Promise<void> {
		if (this.loggingOut()) 
			return;
		
		this.loggingOut.set(true);
		this.userMenuOpen.set(false);
		try {
			await this.operatorStateSrv.logout();
		} finally {
			await this.router.navigateByUrl('/login');
			this.loggingOut.set(false);
		}
	}

	@HostListener('document:click', ['$event'])
	closeMenus(event: Event): void {
		if (!this.elementRef.nativeElement.contains(event.target as Node)) {
			this.storeMenuOpen.set(false);
			this.userMenuOpen.set(false);
		}
	}

	@HostListener('document:keydown.escape')
	closeMenusFromKeyboard(): void {
		this.storeMenuOpen.set(false);
		this.userMenuOpen.set(false);
	}
}
